module.exports = __webpack_public_path__ + "static/media/libro4.c14b62c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/libro4.png
// module id = 352
// module chunks = 0